(function() {
'use strict';

angular
    .module('TR')
    .service('baggageService', baggageService);

function baggageService(occupancyService, tripService, basketStore) {
    const service = {
        getBaggageInfo
    };

    function getBaggageInfo(tripId) {
        return tripService.getTrip(tripId).then(trip => {
            if (trip == null) {
                return [];
            }
            return basketStore.flightSpecificInfo(trip.BasketId).then(flightDetail => {
                if (flightDetail) {
                    return _.map(flightDetail.Sectors, sector => mapBaggageInfo(trip, sector));
                }
                return [];
            });
        });
    }

    function mapBaggageInfo(trip, sector) {
        const bagInfo = {
            holdBagsIncluded: false,
            holdBagCount: 0,
            passengerHoldBags: []
        };

        const flight = trip.FlightsRequest && trip.FlightsRequest.SelectedFlight || {};
        bagInfo.holdBagsIncluded = flight.LeadBaggagePrice === 0;

        if (bagInfo.holdBagsIncluded) {
            bagInfo.holdBagCount = occupancyService.getNumberOfNonInfantPassengers() || 1;
        } else {
            if (sector && sector.PassengerBagCounts) {
                bagInfo.holdBagCount = _.reduce(sector.PassengerBagCounts, (total, bags) => total + bags.Quantity, 0);
                bagInfo.passengerHoldBags = sector.PassengerBagCounts || [];
            }
            if (flight.AllBagsOrNone && bagInfo.holdBagCount > 0) {
                bagInfo.holdBagCount = occupancyService.getNumberOfNonInfantPassengers() || 1;
            }
        }
        return bagInfo;
    }

    return service;
}
})();
